import React, { useState, useEffect } from 'react';
import { Sparkles, X } from 'lucide-react';
import { API_BASE_URL } from '../../api';

interface BannerConfig {
  enabled: boolean;
  text: string;
}

const InfoBanner: React.FC = () => {
  const [config, setConfig] = useState<BannerConfig | null>(null);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    fetchBannerConfig();
  }, []);

  const fetchBannerConfig = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/system-settings/info-banner`);
      if (response.ok) {
        const data = await response.json();
        setConfig(data);
      }
    } catch (error) {
      console.error('Failed to fetch info banner config', error);
    }
  };

  const handleDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem('info_banner_dismissed', 'true');
  };

  useEffect(() => {
    const dismissed = sessionStorage.getItem('info_banner_dismissed');
    if (dismissed === 'true') {
      setIsDismissed(true);
    }
  }, []);

  if (!config || !config.enabled || !config.text || isDismissed) {
    return null;
  }

  return (
    <div className="fixed top-16 inset-x-0 z-40 animate-fade-in-up">
      <div className="mx-4 mt-2 rounded-2xl bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-600 text-white shadow-lg shadow-emerald-500/20 backdrop-blur-sm">
        <div className="container mx-auto flex items-center gap-3 px-4 py-3">
          <div className="flex-shrink-0">
            <Sparkles className="h-5 w-5 text-yellow-200 animate-pulse" aria-hidden="true" />
          </div>
          <p className="font-nunito text-sm md:text-base flex-1 text-center">
            {config.text}
          </p>
          <button
            onClick={handleDismiss}
            className="flex-shrink-0 hover:bg-white/20 rounded-full p-1 transition-colors"
            aria-label="Fermer la bannière"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default InfoBanner;
